import { actions } from './events-actions'
import eventsState from './events-state'

export default (state = eventsState, action) => {
  switch (action.type) {
    case actions.RESET_STATE:
      return Object.assign({}, state, eventsState)
    case actions.SET_SEARCH_FILTER:
      return Object.assign({}, state, {
        searchFilter: action.value
      })
    case actions.FETCH_ALL_DATA:
      return Object.assign({}, state, {
        data: action.payload
      })
    case actions.UPDATE_DATA:
      return Object.assign({}, state, {
        data: action.data
      })
    default:
      return state
  }
}
